import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authApi, billingApi, getAccessToken } from '@/lib/api';

/**
 * Handles root URL (/) redirects after login.
 * Redirects authenticated users to their first business's dashboard.
 * Redirects unauthenticated users to login.
 * Preserves query params (e.g. ?email_verified=1) through the redirect.
 */
export function RootRedirect() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = getAccessToken();
    if (!token) {
      navigate('/login', { replace: true });
      return;
    }

    // Preserve query params through the redirect
    const queryString = searchParams.toString();
    const suffix = queryString ? `?${queryString}` : '';

    authApi.getMe().then(async (response) => {
      if (response.error) {
        navigate('/login', { replace: true });
        return;
      }

      if (!response.data?.businesses || response.data.businesses.length === 0) {
        navigate('/onboarding', { replace: true });
        return;
      }

      const firstBusiness = response.data.businesses[0];
      const billingRes = await billingApi.getStatus(firstBusiness.id);
      const paymentIncomplete = ['incomplete', 'incomplete_expired', 'unpaid'].includes(
        billingRes.data?.subscription_status || ''
      );
      const needsSubscription =
        billingRes.data &&
        !billingRes.data.is_legacy &&
        (!billingRes.data.has_stripe_subscription || paymentIncomplete);

      if (needsSubscription) {
        navigate('/onboarding', { replace: true });
      } else {
        navigate(`/${firstBusiness.id}/dashboard${suffix}`, { replace: true });
      }
    });
  }, [navigate, searchParams]);

  return null;
}
